import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Grid, Button } from '@material-ui/core/'
import Mails from './components/Mails'
import AddMeil from './components/AddMeil'
import SendEmail from './components/SendTemplate'
import apiAdmin from '../../../../../api/admin'
import './index.scss'

const Mailings = () => {
  const [step, setStep] = useState(0)
  const [emails, setEmails] = useState([])
  const [template, setTemlate] = useState({})
  const { user } = useSelector(({ session }) => session)
  const [mergeTags, setMergeTags] = useState(null)

  const getEmails = () => {
    apiAdmin?.getEmails(user?.accessKey)
      .then(({ data }) => setEmails(data?.templates))
      .catch(error => console.error(error))
  }

  const updateTemplate = (templateUuid, json, html) => {
    apiAdmin?.updateTemplate(user?.accessKey, templateUuid, json, html)
      .catch(error => console.error(error))
      .finally(() => {
        getEmails()
        setStep(0)
        setTemlate({})
        setMergeTags(null)
      })
  }

  const createTemplate = (json, html) => {
    apiAdmin?.createTemplate(user?.accessKey, { name: `№${emails?.length + 1}`, renderContext: 1 })
      .then(({ data }) => {
        if (data?.template?.uuid) {
          updateTemplate(data?.template?.uuid, json, html)
        }
      })
      .catch(error => console.error(error))
      .finally(() => setMergeTags(null))
  }

  const deleteTemplate = id => {
    apiAdmin?.deleteTemplate(user?.accessKey, id)
      .then(() => getEmails())
      .catch(error => console.error(error))
  }

  const getTemplateById = (id, step, copi) => {
    apiAdmin?.getTemplateById(user?.accessKey, id)
      .then(({ data }) => {
        if (copi) {
          setTemlate({
            ...data?.template,
            uuid: null,
          })
        } else {
          setTemlate(data?.template)
        }
        if (data?.template?.uuid) {
          setStep(step)
        }
      })
      .catch(error => console.error(error))
  }

  const getTag = index => {
    apiAdmin?.getTag(user?.accessKey, index)
      .then(({ data }) => setMergeTags(data?.mergeTags))
  }

  const pages = {
    0: <Mails emails={emails} deleteTemplate={deleteTemplate} getTemplateById={getTemplateById} />,
    1: <AddMeil setMergeTags={setMergeTags} mergeTags={mergeTags} setStep={setStep} createTemplate={createTemplate} updateTemplate={updateTemplate} template={template} setTemlate={setTemlate} />,
    2: <SendEmail template={template} setStep={setStep} setTemlate={setTemlate} />,
  }

  const content = pages[step] || pages[0]

  useEffect(() => {
    getEmails()
  }, [])

  useEffect(() => {
    if (template?.renderContext) {
      getTag(template?.renderContext)
    }
  }, [template])

  return (
    <Grid className='wrapperMailings'>
      {step === 0 && (
        <Grid>
          <Button
            className='btnAddMail'
            variant='contained'
            color='primary'
            onClick={() => {
              setStep(1)
              getTag(1)
            }}
          >
            ADD TEMPLATE
          </Button>
        </Grid>
      )}
      {content}
    </Grid>
  )
}

export default Mailings
